import React, { useCallback, useEffect, useState } from 'react';
import { ContentDetailsModal } from '@presentation/components/ContentDetailsModal';
import type { ContentService } from '@domain/usecases/content/ContentService';
import Modal from '@mui/material/Modal';
import { useGetContentDetails } from '@presentation/modals/ContentDetails/hooks';
import { Loader } from '@presentation/components/Loader';
import { Content } from '@presentation/modals/ContentDetails/styles';

const ContentDetails = ({
	id,
	open,
	onClose,
	contentService,
}: {
	id: string;
	open: boolean;
	onClose: () => void;
	contentService: ContentService;
}) => {
	const { content, appLink, isLoading, reset } = useGetContentDetails(id, contentService);
	const [prevTitle, setPrevTitle] = useState<string>('');

	const close = useCallback(() => {
		document.title = prevTitle;
		reset();
		onClose();
	}, [onClose, reset, prevTitle]);

	const onKeyDown = useCallback(
		(event: any) => {
			if (event.key !== 'Escape') {
				return;
			}

			event.stopPropagation();

			close();
		},
		[close]
	);

	useEffect(() => {
		if (!isLoading && content === null) {
			onClose();
		}
	}, [isLoading, content, onClose]);

	useEffect(() => {
		if (content) {
			setPrevTitle(document.title);
			document.title = `${content.name} Jigsaw Puzzle`;
		}
	}, [content]);

	return (
		<Modal open={open} onClose={close}>
			<Content onKeyDown={onKeyDown}>
				{isLoading && <Loader />}
				{content && !isLoading && <ContentDetailsModal onClose={close} content={content} linkInApp={appLink} />}
			</Content>
		</Modal>
	);
};

export default ContentDetails;
